import * as ROUTES from "../routes/routes"

export const getRoutes = () => {
  return ROUTES
}
